import { MessageCircle, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { ChatWindow } from "./ChatWindow";
import { useChat } from "../../hooks/useChat";
import { useAuth } from "../../hooks/useAuth";
import { useBranding } from "../../hooks/useBranding";
import { useLocation } from "react-router-dom";

export function ClaimsChatWidget() {
  const { pathname } = useLocation();
  const { user, loading } = useAuth();
  const { branding } = useBranding();
  const {
    messages,
    isLoading,
    isOpen,
    sendMessage,
    toggleChat,
    setIsOpen,
    clearMessages,
  } = useChat();

  // Don't show on login/setup pages, or before auth is ready
  if (loading || !user || pathname === "/login" || pathname === "/complete-setup") return null;

  return (
    <div className="claims-chat-widget">
      <AnimatePresence>
        {isOpen && (
          <ChatWindow
            messages={messages}
            isLoading={isLoading}
            onSendMessage={sendMessage}
            onClose={() => setIsOpen(false)}
            onClear={clearMessages}
            logoUrl={branding.logo_url || undefined}
            companyName={branding.company_name || branding.app_name}
          />
        )}
      </AnimatePresence>

      <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
        <button
          onClick={toggleChat}
          className={`claims-chat-fab ${isOpen ? "claims-chat-fab--open" : ""}`}
          aria-label={isOpen ? "Close chat" : "Open chat"}
        >
          {isOpen ? (
            <X size={24} color="#fff" />
          ) : (
            <MessageCircle size={24} color="#fff" />
          )}
        </button>
      </motion.div>
    </div>
  );
}
